var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                attrs: {
                  "config-module": "20240301",
                  reset: true,
                  "custom-sim-query-placeholder": _vm.$t(
                    "Message.QuickSearchBusinessNo"
                  ),
                  "auto-init": _vm.searchItemAutoInit,
                  "custom-search-items": _vm.customSearchItems
                },
                on: {
                  "click-more": function(value) {
                    return (_vm.isAdvancedQuery = value)
                  },
                  simSearchItemCallBack: _vm.toSimpleQuery,
                  advSearchItemCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _vm.checkPermission(["button_SupplierCharge_confirmCharge"])
                      ? _c(
                          "el-button",
                          {
                            attrs: { no: "button1", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.toPassChargeSyncOut()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.confirmCharge")))]
                        )
                      : _vm._e(),
                    _vm.checkPermission(["button_SupplierCharge_refuseCharge"])
                      ? _c(
                          "el-button",
                          {
                            attrs: { no: "button2", type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.toNotPassChargeSyncOut()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "button3", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.toRefresh()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Refresh")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "button4", type: "primary" },
                        on: { click: _vm.toManualMatching }
                      },
                      [_vm._v(_vm._s(_vm.$t("Clearing.ManualMatching")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "2024030101",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "total-wrapper", class: ["fixedBottom"] },
                  [
                    _c("charge-currency-total-group", {
                      attrs: {
                        "ar-field": "receivable",
                        "currency-field": "currency",
                        "data-field": "amount",
                        "data-provider":
                          _vm.selectedRows.length > 0
                            ? _vm.selectedRows
                            : _vm.rowData,
                        "ar-label": _vm.$t("Message.Receivable"),
                        "ap-label": _vm.$t("Message.Payable")
                      }
                    })
                  ],
                  1
                ),
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "990010",
                    total: _vm.total,
                    "page-count": _vm.pageCount,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toQueryByPage
                  }
                })
              ],
              1
            ),
            _vm.rejectWindow.visible
              ? _c("reject-dialog", {
                  attrs: {
                    visible: _vm.rejectWindow.visible,
                    "job-no": _vm.rejectWindow.jobNo,
                    "reject-call-back": _vm.rejectWindow.rejectCallBack,
                    "append-to-body": true
                  },
                  on: {
                    "update:visible": function($event) {
                      return _vm.$set(_vm.rejectWindow, "visible", $event)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.matchDialog.visible,
            title: _vm.$t("Clearing.SelectBusinessNumber"),
            width: "1000px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.matchDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: {
                    "label-width": "60px",
                    inline: "",
                    "label-position": "left"
                  }
                },
                [
                  _vm.matchDialog.type === 0
                    ? [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("queryJob.containerNo") } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.matchDialog.supplierOrderNo,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.matchDialog,
                                    "supplierOrderNo",
                                    $$v
                                  )
                                },
                                expression: "matchDialog.supplierOrderNo"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm.matchDialog.type === 1
                    ? [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("queryJob.warehouseNo") } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.matchDialog.supplierOrderNo,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.matchDialog,
                                    "supplierOrderNo",
                                    $$v
                                  )
                                },
                                expression: "matchDialog.supplierOrderNo"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("queryJob.businessNumber") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              model: {
                                value: _vm.matchDialog.jobNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.matchDialog, "jobNo", $$v)
                                },
                                expression: "matchDialog.jobNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("queryJob.mblNo") } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              model: {
                                value: _vm.matchDialog.mbl,
                                callback: function($$v) {
                                  _vm.$set(_vm.matchDialog, "mbl", $$v)
                                },
                                expression: "matchDialog.mbl"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "SO NO." } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              model: {
                                value: _vm.matchDialog.soNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.matchDialog, "soNo", $$v)
                                },
                                expression: "matchDialog.soNo"
                              }
                            })
                          ],
                          1
                        )
                      ]
                ],
                2
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "5px" } },
                [
                  _c(
                    "el-button",
                    {
                      style: { width: "100px", marginLeft: "20px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.toQueryJob }
                    },
                    [_vm._v(_vm._s(_vm.$t("queryJob.Search")))]
                  ),
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: {
                        float: "right",
                        "margin-top": "15px",
                        "margin-right": "20px"
                      },
                      on: { change: _vm.onTypeChange },
                      model: {
                        value: _vm.matchDialog.type,
                        callback: function($$v) {
                          _vm.$set(_vm.matchDialog, "type", $$v)
                        },
                        expression: "matchDialog.type"
                      }
                    },
                    [
                      _c("el-radio", { ref: "boxNo", attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("Clearing.ManualMatchByBoxNo")))
                      ]),
                      _c(
                        "el-radio",
                        { ref: "warehouseNo", attrs: { label: 1 } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Clearing.ManualMatchByWarehouseNo"))
                          )
                        ]
                      ),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(_vm._s(_vm.$t("Clearing.FreeMatch")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                staticStyle: { padding: "15px 20px 10px 20px" },
                attrs: {
                  "config-module": "2024030102",
                  "grid-options": _vm.matchDialog.gridOptions,
                  "column-defs": _vm.matchDialog.columnDefs,
                  "row-data": _vm.matchDialog.rowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "100px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.saveJobNo }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Confirm")))]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { width: "100px" },
                  on: {
                    click: function($event) {
                      _vm.matchDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ]
        },
        [
          _c(
            "el-radio-group",
            { attrs: { value: 1 } },
            [
              _c("el-radio", { ref: "trueRadioTemplate", attrs: { label: 1 } }),
              _c("el-radio", { ref: "falseRadioTemplate", attrs: { label: 0 } })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }